module.exports = __webpack_public_path__ + "img/message-bot.5a04ee2b.svg";